"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _colors = require("../../../styles/colors");
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const ROWS_NUM = 10;
const COLUMNS_NUM = 5;
const FinishLineSuqared = _ref => {
  let {
    customStyles
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "squared-finish-line-container",
    style: _objectSpread({
      gridTemplateColumns: "repeat(".concat(COLUMNS_NUM, ", 1fr)"),
      gridTemplateRows: "repeat(".concat(ROWS_NUM, ", 1fr)")
    }, customStyles),
    children: new Array(ROWS_NUM).fill(0).map((_, rowIdx) => {
      return new Array(COLUMNS_NUM).fill(0).map((_, columnIdx) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "square",
          style: {
            backgroundColor: (rowIdx + columnIdx) % 2 === 0 ? _colors.MAIN_BLUE : "white"
          }
        }, rowIdx + columnIdx);
      });
    })
  });
};
var _default = exports.default = FinishLineSuqared;